import { render, staticRenderFns } from "./ModalEmployees.vue?vue&type=template&id=052e59b2&scoped=true&lang=pug&"
import script from "./ModalEmployees.vue?vue&type=script&lang=js&"
export * from "./ModalEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmployees.vue?vue&type=style&index=0&id=052e59b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e59b2",
  null
  
)

export default component.exports